export default __webpack_public_path__ + "static/media/send_arrow_disabled.ac314daf.svg";